/* eslint-disable no-useless-escape */
export const regexList = {
  userName: /^[a-zA-Z0-9]+$/,
  loginPassword_rule1:
    /^([a-zA-Z0-9!~`#$%^&*+=()_\-\\[\]{};':"\\|,.>\\/?]{6,20})$/,
  loginPassword_rule2: /[~`#$%^&*+=()_\-\\[\]{};':"\\|,.>\\/?!]/g,
  lastName: /^([a-zA-Z][a-zA-Z\-\\'\s]*|)$/,
  lastNameLength: /^.{1,40}$/,
  userIdLength: /^.{6,132}$/,
  isNaN: /[^\d]/,
  skyMilesNumber: /^[\d]{9,10}$|^[\d]{12}$/,
  email: /^[\w-]+(?:\.[\w-]+)*@([a-z0-9-]+\.)+[a-z]{2,13}$/i,
  firstName: /^([a-zA-Z][a-zA-Z\-'\s]*|)$/,
  firstNameLength: /^.{1,25}$/,
  flyingClubNumber: /^[\d]{10,11}$/,
  securityAnswer: /^([a-zA-Z\d][a-zA-Z\d\-\\.\\'\s]*|)$/,
  country: /^[A-za-z0-9!@$%^&*()+{}=#<>.?\\`\\~:;\\[\],"\s]+$/,
  state: /^[A-za-z0-9!@$%^&*()+{}=#<>.?\\`\\~:;\\[\],"\s]+$/,
  city: /^[A-za-z0-9!@$%^&*()+{}=#<>.?\\`\\~:;\\[\],"\s]+$/,
  addressLineLength: /^.{1,40}$/,
  addressLine1: /^[A-za-z0-9]((?![\!@$%^#*()+=<>.?\`\~:;\[\]\{\}\&\"]).)+$/,
  addressLine2: /^[A-za-z0-9!@#$%^*()+=<>.?\`\~:;\[\]\|\{\}\&,"\s]+$/,
  district: /^[A-za-z0-9!@$%^&*()+{}=#<>.?\`\~:;\[\],"\s]+$/,
  cityAddAddress: /^[A-za-z0-9!@$%^&*()+{}=#<>.?\`\~:;\[\],"\s]+$/,
  zipCode: /^[\d\w\-\s\.]{2,12}$/
};

export const createNewPasswordRegExList = {
  mustContain: [
    /^.{8,20}$/,
    /^(?=.*[0-9])(?=.*[a-z]|[A-Z])/,
    /^(?=.*[A-Z])(?=.*[a-z])/
  ],
  cannotContain: [
    /(.*[~`#$%^&*+=()_\-[\]{};':"\\|,.>/?!]){4,}/,
    /[@<]/i,
    /^[\d]{9,10}$|^[\d]{12}$|^[\w-]+(?:\.[\w-]+)*@([a-z0-9-]+\.)+[a-z]{2,13}$/
  ]
};

export const nameConfig = {
  nameLengthConfig: false as boolean | undefined
};
